// extracted by mini-css-extract-plugin
module.exports = {"ssoFailureContainer":"ssoFailure_ssoFailureContainer__1qNoW","logo":"ssoFailure_logo__N2EQD","title":"ssoFailure_title__1LRXZ"};